import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import PurgeLogFileFormHandle from '../containers/formHandlers/PurgeLogFileFormHandle/PurgeLogFileHandle';

export default function PurgeLogFile() {
  return (
    <>
      <CC.Box w="full" maxW="lg" mx="auto">
        <CC.Box>
          <CC.Heading as="h2" size="lg" mb="4">
            Purge Fichier Log Utilisateurs
          </CC.Heading>
        </CC.Box>

        <PurgeLogFileFormHandle />
      </CC.Box>
    </>
  );
}
